<template>
  <component
    :is="iconComponent"
    class="app-icon"
    :class="[`is-${size}`]"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from "vue"
import {
  ArrowLeftRight,
  Camera,
  ChevronDown,
  Circle,
  Download,
  FileText,
  HardDrive,
  LoaderCircle,
  Monitor,
  Pause,
  Pencil,
  Play,
  RefreshCw,
  Settings,
  Square,
  Terminal,
  Trash2,
  X
} from "lucide-vue-next"

const props = defineProps({
  name: {
    type: String,
    default: "circle"
  },
  size: {
    type: String,
    default: "md"
  }
})

const normalizedName = computed(() => String(props.name || "").trim() || "circle")

const ICONS = {
  edit: Pencil,
  pencil: Pencil,
  delete: Trash2,
  trash: Trash2,
  download: Download,
  close: X,
  play: Play,
  stop: Square,
  pause: Pause,
  refresh: RefreshCw,
  disk: HardDrive,
  file: FileText,
  desktop: Monitor,
  terminal: Terminal,
  migrate: ArrowLeftRight,
  settings: Settings,
  "chevron-down": ChevronDown,
  camera: Camera,
  spinner: LoaderCircle,
  circle: Circle
}

const iconComponent = computed(() => ICONS[normalizedName.value] || ICONS.circle)
</script>

<style scoped>
.app-icon {
  display: inline-block;
  vertical-align: middle;
  flex: 0 0 auto;
}

.app-icon.is-sm {
  width: 14px;
  height: 14px;
}

.app-icon.is-md {
  width: 16px;
  height: 16px;
}

.app-icon.is-lg {
  width: 18px;
  height: 18px;
}
</style>
